<script setup>
const props = defineProps({
  filters: {
    type: Array,
    default: null,
  },
  items: {
    type: Array,
    required: true,
  },
})

const openFilter = ref('')

const filteredItems = computed(() =>
  activeFilters.value.length > 0
    ? props.items.filter(
        (item) => activeFilters.value.indexOf(item.category) !== -1
      )
    : props.items
)
const activeFilters = ref([])
const openIndex = ref(null)

// Handlers
function onOpen(index) {
  openIndex.value = index
}

function onClose(index) {
  if (openIndex.value === index) {
    openIndex.value = -1
  }
}

function onFilterChange(filters) {
  activeFilters.value = filters
}

function onFilterClosed(id) {
  if (openFilter.value === id) {
    openFilter.value = -1
  }
}

const onFilterOpened = (id) => {
  openFilter.value = id
}
</script>

<template>
  <section class="module-faq">
    <DropdownFilters
      v-if="filters"
      filtersButtonLabel="Filter By"
      :open="openFilter === 'faqFiltersModal'"
      modalId="faqFiltersModal"
      :filters="filters"
      @filter-changed="onFilterChange"
      @filter-opened="onFilterOpened"
      @filter-closed="onFilterClosed"
    />

    <ol class="module-faq__list">
      <ModuleFAQItem
        v-for="(item, index) in filteredItems"
        :key="`FAQ-${index}`"
        :title="item.title"
        :content="item.content"
        :image="item.image"
        :callToAction="item.callToAction"
        :call-to-action-gtm-class="item.callToActionGtmClass"
        :index="index"
        :is-open="index === openIndex"
        @open="onOpen"
        @close="onClose"
      />
    </ol>
  </section>
</template>

<style lang="scss">
// Utils
@import 'styles/utils/variables';
@import 'styles/utils/functions';
@import 'styles/utils/timing-functions';

// Vendors
@import 'styles/vendors/sass-mq/mq';

.module-faq {
  position: relative;

  @include mq($from: 'l') using ($from) {
    display: flex;
  }

  .dropdown-filters {
    display: none;
    @include mq($from: 'l') using ($from) {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }
  }

  &__list {
    counter-reset: ol;
    width: 100%;

    @include mq($from: 'l') using ($from) {
      max-width: gs(12, 11, 'l');
      margin: 0 auto;
    }
  }
}
</style>
